import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ParserPropertyModel } from "../parser.model";

@Component({
    selector: 'parser-format-display',
    templateUrl: './parser-format-display.component.html',
    styleUrls: ['./parser-format-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ParserFormatDisplayComponent  {

    @Input() appendComma: boolean = false;
    @Input() model: ParserPropertyModel

    constructor() { }

}
